import React from 'react';

const FloatingIcons = () => {
  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col space-y-4">
      <a href="https://www.linkedin.com/company/arktemis-group/" target="_blank" rel="noopener noreferrer" className="block p-4 bg-gray-800 text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-300">
        <i className="fab fa-linkedin-in text-xl"></i> {/* Placeholder for LinkedIn icon */}
      </a>
      <a href="https://www.instagram.com/arktemisfoundation?igsh=MTQwcDJhczRwM216" target="_blank" rel="noopener noreferrer" className="block p-4 bg-gray-800 text-white rounded-full shadow-lg hover:bg-pink-700 transition-colors duration-300">
        <i className="fab fa-instagram text-xl"></i> {/* Placeholder for Instagram icon */}
      </a>
    </div>
  );
};

export default FloatingIcons;